module.exports = __webpack_public_path__ + "img/index_pic32.36676646.png";